// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","container":"G94d3fd G8ee4b2 G57d356 G546335 G60c266 Gf6ccc7"};